import ProfileSetting from '@/Component/Profile/ProfileSetting'
import Permissions from '@/Component/Profile/ProfileSetting/Permissions'

const PermissionsPage = () => {
    return (
        <ProfileSetting activeTab="permissions">
            <Permissions />
        </ProfileSetting>
    )
}

export default PermissionsPage
